import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { keyframes } from "@mui/system";
import { tokens } from '../../theme';
import { Box, Typography } from '@mui/material';
const pulse = keyframes`
0% { opacity: .3; transform: scale(.95); }
50% { opacity: 1; transform: scale(1.05); }
100% { opacity: .3; transform: scale(.95); }
`;

const ThinkingIndicator = () => (
    <Box
        sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            py: 4,
            px: 3,
            mt: 2,
            borderRadius: 3,
            border: `1px solid ${tokens.color.borderTertiary}`,
            background: tokens.color.bgSecondary
        }}
    >
        <AutoAwesomeIcon
            sx={{
                animation: `${pulse} 1.4s infinite`,
                color: tokens.color.textPrimary
            }}
        />

        <Typography sx={{ color: tokens.color.textSecondary }}>
            Searching learning content and generating the best answer
        </Typography>
    </Box>
);

export default ThinkingIndicator;